import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import { navigateTo } from "@utils/navigate";
import rollbar, { LogMetadata } from "@utils/rollbar";

const createStripeBillingPortalSession = async (): Promise<ApiResponse<{ url: string }>> => {
  try {
    const response = await paymentGatewayApi.post<{ url: string }>(
      "/v1/subscriptions/self-service-dashboard",
      undefined,
      { requireAuth: true }
    );
    navigateTo(response.data.url);
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/subscriptions/self-service-dashboard", method: "POST" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error creating billing portal session" };
  }
};

export default createStripeBillingPortalSession;
